import { render, staticRenderFns } from "./orderCustomize.vue?vue&type=template&id=49abf8d4"
import script from "./orderCustomize.vue?vue&type=script&lang=js"
export * from "./orderCustomize.vue?vue&type=script&lang=js"
import style0 from "./orderCustomize.vue?vue&type=style&index=0&id=49abf8d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports